import {
  Button,
  ButtonTheme,
  MultilineTextField,
  Preloader,
  TextField,
  Tooltip,
  TooltipPosition,
  VisualSize,
} from '@cian/components';
import * as React from 'react';
import * as Modal from 'react-modal';

import { EStatusFetch } from '../../store/bti_error_data_popup';
import { IconClose } from './icons/icon_close';

import * as styles from './index.css';
import { isEmail } from '../../utils/validate';

export interface IBtiErrorDataPopupProps {
  isOpen: boolean;
  statusFetch: EStatusFetch;
  error: string;
}

export interface IBtiErrorDataPopupDispatchProps {
  closeBtiDataErrorPopup(): void;
  submitFeedback(host: string, email: string, message: string, url: string): void;
}

export interface IBtiErrorDataPopupState {
  email: string;
  emailError: string;
  globalError: string;
  message: string;
  messageError: string;
}

export type IProps = IBtiErrorDataPopupProps & IBtiErrorDataPopupDispatchProps;

export class BtiErrorDataPopup extends React.Component<IProps, IBtiErrorDataPopupState> {
  public state = {
    email: '',
    emailError: '',
    globalError: '',
    message: '',
    messageError: '',
  };

  public UNSAFE_componentWillReceiveProps(nextProps: IBtiErrorDataPopupProps) {
    if (nextProps.error) {
      this.setState({
        globalError: nextProps.error,
      });
    }

    if (nextProps.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';

      this.setState({
        email: '',
        emailError: '',
        message: '',
        messageError: '',
      });
    }
  }

  public render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        onRequestClose={this.props.closeBtiDataErrorPopup}
        style={{
          content: {
            overflow: 'visible',
            padding: '24px 30px',
            position: 'static',
            width: '500px',
            zIndex: 101,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, .8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 100,
          },
        }}
      >
        <div className={styles['header']}>
          <div className={styles['title']}>
            {this.props.statusFetch === EStatusFetch.ok ? 'Спасибо за ваш отзыв' : 'Ошибка в данных?'}
          </div>
          <button className={styles['close']} onClick={this.props.closeBtiDataErrorPopup}>
            <IconClose />
          </button>
        </div>
        {this.props.statusFetch !== EStatusFetch.ok && (
          <form className={styles['form']} onSubmit={this.handleSubmit}>
            <div>
              <label htmlFor="message">Кратко опишите, в каких данных у нас ошибки</label>
              <Tooltip
                tooltipContent={this.state.messageError}
                position={TooltipPosition.RIGHT_CENTER}
                tooltipStyles={styles['tooltip_multiline']}
              >
                <MultilineTextField
                  invalid={!!this.state.messageError}
                  onValueChange={this.changeMessage}
                  value={this.state.message}
                  minRows={5}
                />
              </Tooltip>
            </div>
            <div>
              <label htmlFor="email">Ваш email</label>
              <Tooltip tooltipContent={this.state.emailError} position={TooltipPosition.RIGHT_CENTER}>
                <TextField
                  id="email"
                  invalid={!!this.state.emailError}
                  onValueChange={this.changeEmail}
                  value={this.state.email}
                  size={VisualSize.SMALL}
                />
              </Tooltip>
            </div>
            <div className={styles['submit']}>
              {this.props.statusFetch === EStatusFetch.isLoad && (
                <div className={styles['preloader']}>
                  <Preloader size={16} />
                </div>
              )}
              <Button type="submit" theme={ButtonTheme.BLUE_SOLID}>
                Отправить
              </Button>
            </div>
          </form>
        )}
      </Modal>
    );
  }

  private changeMessage = (message: string) => {
    this.setState({
      message,
      messageError: '',
    });
  };

  private changeEmail = (email: string) => {
    this.setState({
      email,
      emailError: '',
    });
  };

  private handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const message = this.state.message.trim();
    const email = this.state.email.trim();

    if (!message) {
      this.setState({
        messageError: 'Введите текст',
      });

      return;
    }

    if (!email) {
      this.setState({
        emailError: 'Введите email',
      });

      return;
    }

    if (!isEmail(email)) {
      this.setState({
        emailError: 'Неправильный формат почты',
      });

      return;
    }

    this.props.submitFeedback(window.location.host, email, message, window.location.href);
  };
}
